export const QR_PAYMENT_TYPES = {
  INSTANT_DELIVERY_QR: 1, // Direct UPI Payment QR
  SCAN_AND_PAY_QR: 2, // Standard Payment Gateway QR
};

export const QR_PAYMENT_TYPE_KEYS = {
  UPI: "upi",
};

export const QR_SELECTION_OPTIONS = [
  {
    id: QR_PAYMENT_TYPES.INSTANT_DELIVERY_QR,
    title: "Direct UPI Payment QR",
    description:
      "Best for quick mobile payments. Scans to directly launch UPI apps like Paytm, Google Pay, PhonePe etc.",
    disabled: false,
  },
  {
    id: QR_PAYMENT_TYPES.SCAN_AND_PAY_QR,
    title: "Standard Payment Gateway QR",
    description:
      "Best for diverse payment preferences. Takes customers to the checkout page with Credit Card, Net Banking, Wallet, & UPI options.",
    disabled: false,
  },
];

export const QR_PAYMENT_STATUS = {
  pending: 1,
  success: 2,
};

export const QR_CODE_API_BASE_URL =
  "https://api.qrserver.com/v1/create-qr-code/";

export const getQrImageUrl = (data, size = 300) =>
  `${QR_CODE_API_BASE_URL}?size=${size}x${size}&data=${encodeURIComponent(
    data
  )}`;

export const QR_FLOW_PARAMS = {
  UPI_PARAM: "flow=upi",
};

export const MODAL_WIDTHS = {
  QR: "620px",
};

export const QR_MODAL_TITLES = {
  SELECT_TYPE: "Select QR Code Type",
  SCAN_OR_DOWNLOAD: "Scan / Download QR Code",
};

export const QR_FILE_CONSTANTS = {
  DEFAULT_NAME: "payment",
  SUFFIX_QR: "qr",
  FILENAME_REGEX: /[^a-z0-9]+/g,
};

export const QR_MODAL_NUMBERS = {
  QR_CODE_SIZE: 500,
  QR_CODE_DOWNLOAD_SIZE: 50,
};
